import _axios from '../../apiClient'


export function exportarPagosPedidosCsvAsync(params) {
  // Construir el query string según la estructura que espera el backend
  const queryString = new URLSearchParams();
  
  // Parámetros requeridos (ajusta según tu implementación real)
  queryString.append('FiltroFecha', params.filtroFecha || 'Ultimos30Dias');
  
  // Parámetros opcionales
  if (params.estados && params.estados.length > 0) {
    params.estados.forEach(estado => {
      queryString.append('Estados', estado);
    });
  }
  
  if (params.desde) queryString.append('Desde', params.desde);
  if (params.hasta) queryString.append('Hasta', params.hasta);

  return _axios.get(`/api/pedido/ExportarPagosCsv?${queryString.toString()}`, {
    responseType: 'blob',
    headers: { 
      'Accept': 'application/octet-stream'
    }
  })
  .then(response => {
    return response;
  })
  .catch((error) => {
    const data = error.response?.data || { message: 'Error desconocido' };
    throw data;
  });
}

export function obtenerFiltrosEstados() {
  return _axios.get(`/api/pedido/ObtenerFiltrosEstados`, {
    responseType: 'json',
    headers: { 
      'Accept': 'application/json'
    }
  })
  .then(response => {
    return response.data;
  })
  .catch((error) => {
    const data = error.response?.data || { message: 'Error desconocido' };
    throw data;
  });
}